import React from "react";

//True once the window has scrolled past the given offset
export const useScrolledPast = (offset) => {
  const [isPast, setIsPast] = React.useState(false);

  React.useEffect(() => {
    const onScroll = () => setIsPast(window.scrollY > offset);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [offset]);

  return isPast;
};
